/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-21 23:50:51
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-09 11:23:24
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/hooks/customHooks.tsx
 */
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { useHistory } from 'react-router';

import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const switchUuidHooks = (getUuid) => {
  const _h = useHistory();

  const _d: any = useSelector(getUuid());
  const { uuid, contentUuid, salesChannelUuid } = _d;
  const _params: { contentPageUuid: string } = useParams();
  const { contentPageUuid } = _params;

  useAfterDidMountEffect(() => {
    if (uuid !== contentPageUuid) {
      _h.push(
        `/salesChannel/editor/content/contentPage/${salesChannelUuid}/${contentUuid}/${uuid}`,
      );
    }
  }, [uuid]);
};
export { switchUuidHooks };
